import * as t from 'io-ts';
import { detailCodec, formCodec, listCodec, recordCodec } from '@/services/api/resources/notification';

export type Notification = t.TypeOf<typeof formCodec>;
export type NotificationRecord = t.TypeOf<typeof recordCodec>;
export type NotificationList = t.TypeOf<typeof listCodec>;
export type NotificationDetail = t.TypeOf<typeof detailCodec>;

export const emptyNotification: Notification = {
  subject: '',
  message: '',
  createdAt: new Date(),
  readAt: null,
};
